module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-row', {
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', [_c('date-range-picker', {
    model: {
      value: (_vm.reportRange),
      callback: function($$v) {
        _vm.reportRange = $$v
      },
      expression: "reportRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadReport()
      }
    }
  }, [_c('span', [_vm._v("Generuj XLS")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "download"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Numer faktury")]), _vm._v(" "), _c('th', [_vm._v("Korekta")]), _vm._v(" "), _c('th', [_vm._v("Data dodania")]), _vm._v(" "), _c('th', [_vm._v("Nazwa klienta")]), _vm._v(" "), _c('th', [_vm._v("Netto (" + _vm._s(_vm.currency.name) + ")")]), _vm._v(" "), _c('th', [_vm._v("Brutto (" + _vm._s(_vm.currency.name) + ")")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items.list), function(invoice) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(invoice.fullNumber))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("translate")(invoice.correction)))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("date")(invoice.date.date)))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(invoice.customerName))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("amountFormat")(invoice.net)))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("amountFormat")(invoice.gross)) + " ")])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "tr-summary"
  }, [_c('td', {
    staticClass: "td-no_link text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Suma")]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.items.totalNet)) + " ")])]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.items.totalGross)) + " ")])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e4420d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Invoice.vue
// module id = 783
// module chunks = 0